import { useEffect } from 'react';

import { Func } from '@/utils/ts';

export default function useFirstRenderEffect(func: Func): void {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => func(), []);
}
